<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to')}} {{$t('industry.singular')}}
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
              <button 
                type="submit" 
                class="btn2 btn2-primary btn-sm"
              ><i class="uil uil-edit mr-1"></i>{{$t('common.save')}}</button>
          </div>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('industry.form.information')}}</h4>
            <p class="sub-header"></p>

            <div class="row">

              <div class="col-md-6">
                <TextField 
                  :placeholder="$t('industry.form.name.label')"
                  :label="$t('industry.form.name.label')"
                  v-model="model.name"
                  :error="$v.model.name.$error"
                  :errorMessage="$v.model.name.errorMessage"
                />
              </div>

            </div>
            <div class="row">

              <div class="col-md-12">
                <div class="form-group">
                  <label for="remarks" class="form-label">{{$t('industry.form.remarks.label')}}</label>
                  <textarea
                    class="form-control" 
                    name="remarks"
                    :placeholder="$t('industry.form.remarks.placeholder')"
                    rows="10"
                    v-model="model.remarks"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import TextField from '@components/form/textfield.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'


export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        name: '',
        remarks: '',
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  components:{FixedHeader, TextField},
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  created(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('industry', ['create', 'update', 'find']),
    onView() {
      if(this.$route.query.id){
        this.$router.push('/master_files/industry/view?id=' + this.$route.query.id)
      }else{
        this.$router.push('/master_files/industry')
      }
    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}
      
      this[!this.model.id ? 'create' : 'update'](this.model)
      .then(()=> {
        this.toggleLoading()
         this.$router.push('/master_files/industry')
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/company')
    }
  },
  beforeMount() {
    let id = this.$route.query.id
    if(id){
      this.find({
        id:id
      }).then(data => {
        this.model.name = data.data.name
        this.model.remarks = data.data.remarks
        this.model.id = data.data._id
      })
    }
  }
}
</script>

